module.exports = __webpack_public_path__ + "img/th.3b90388d.svg";